<div class="container mt-4">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Tarefas</li>
    </ol>
  </nav>

  <div class="list-header">
    <div class="list-header__title">
      <h1 class="mb-0">Lista de Tarefas</h1>
      <span class="result-badge" *ngIf="totalElements > 0">{{ totalElements }} registros</span>
    </div>
    <button mat-raised-button color="primary" (click)="router.navigate(['/tasks/create'])">
      <mat-icon>add</mat-icon>
      Nova Tarefa
    </button>
  </div>

  <!-- Filtro -->
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>Buscar tarefa</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Digite para filtrar..." />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Tabela -->
  <div class="table-container mat-elevation-z2">
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- Título -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
          <td mat-cell *matCellDef="let task">
            <span class="cell-text" [matTooltip]="task.title">{{ task.title }}</span>
          </td>
        </ng-container>

        <!-- Usuário -->
        <ng-container matColumnDef="personName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuário</th>
          <td mat-cell *matCellDef="let task">
            <div class="person-cell">
              <mat-icon class="person-icon">person</mat-icon>
              <span>{{ task.personName }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Data de Início -->
        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Início</th>
          <td mat-cell *matCellDef="let task">{{ task.startDate | date: "dd/MM/yyyy" }}</td>
        </ng-container>

        <!-- Data de Fim -->
        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Fim</th>
          <td mat-cell *matCellDef="let task">{{ task.endDate | date: "dd/MM/yyyy" }}</td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let task">
            <span class="status-badge" [ngClass]="'status-' + task.status?.toLowerCase()">
              {{ statusLabel(task.status) }}
            </span>
          </td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Ações</th>
          <td mat-cell *matCellDef="let task" class="actions-cell">
            <button mat-icon-button color="primary" (click)="onEdit(task)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="onDelete(task)" matTooltip="Excluir">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell empty-state" [attr.colspan]="displayedColumns.length">
            <img src="../../../../../assets/img/folder.png" alt="Nenhum resultado" width="80" />
            <p class="empty-state__text">Nenhuma tarefa encontrada.</p>
            <button mat-stroked-button color="primary" (click)="router.navigate(['/tasks/create'])">
              Criar primeira tarefa
            </button>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="currentPage"
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecionar página"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</div>
